module.exports = __webpack_public_path__ + "img/fenetre.e315f22e.png";